import { Layout } from "../components/layout";
import { PageHeader } from "../components/page-header";
import PageSection from "../component-factory/page-section";
import * as React from "react";
import SEO from "../components/seo/seo";
import { SavedSearchProps } from "../types/vino-data-types";
import SearchProvider from "../contexts/search/provider";

const ContentfulPage: React.FC<SavedSearchProps> = ({
  pageContext,
}): JSX.Element => {
  const { savedSearch, pagePath } = pageContext;
  const { title, pageSections } = savedSearch;

  return (
    <Layout pathname={pagePath}>
      <SEO title={title} pathname={pagePath} />
      <SearchProvider>
        <PageHeader {...savedSearch} pagePath={pagePath} />
        {pageSections.map((section, index) => {
          return PageSection.create(section, index);
        })}
      </SearchProvider>
    </Layout>
  );
};

export default ContentfulPage;
